<template>
  <div>
    <v-tooltip top :disabled="tooltipIsEmpty">
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <v-btn
            :class="classes"
            :color="color"
            :small="small"
            :large="large"
            :to="to"
            :disabled="disabled"
            :width="width"
            :height="height"
            :elevation="elevation"
            :rounded="rounded"
            :text="text"
            @click="onClick"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              width="2"
              size="20"
            />
            <slot v-else></slot>
          </v-btn>
        </span>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    to: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: [String, Number],
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: [Number, String],
      default: null,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return [
        'action-text',
        'text-none',
        { 'grey--text text--darken-1': this.color === null },
        { ['grey lighten-2']: this.color === null },
        { 'no-padding': this.noPadding },
        { border: this.border },
      ];
    },
    tooltipIsEmpty() {
      return this.tooltip === null || this.tooltip.trim() === '';
    },
  },
  methods: {
    onClick() {
      if (!this.loading) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.no-padding {
  min-width: 0 !important;
  padding: 0 !important;
}
.v-btn.border {
  border: 1px solid map-get($grey, 'lighten-2') !important;
}
</style>
